import { LectureQuestionDetailResponse } from '../../../types/video'
import { useApiPostQuery } from '../useApi'

export const useQuestionsDetail = (requestData = {}) => {
  return useApiPostQuery<LectureQuestionDetailResponse>(
    '/lectures/questions/detail',
    ['questionsDetail', requestData],
    requestData,
    true
  )
}
